interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "ARS";
};

const ARS: Currency = Object.freeze({
  "displayName": "Argentine Peso",
  "numericCode": 32,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "before",
  "isoCode": "ARS",
  "symbol": "$"
});

export { ARS };
